module.exports = __webpack_public_path__ + "static/media/story.621754c3.png";